import WarningIcon from "@ancon/wildcat-ui/shared/icons/warning-fill.svg";
import BodyText from "@ancon/wildcat-ui/web/orderweb/BodyText";
import Button from "@ancon/wildcat-ui/web/orderweb/Button";

import styles from "./CheckoutOutOfStockBanner.module.scss";

type CheckoutOutOfStockBannerProps = {
  warningText?: string;
  onReviewCartClick?: () => void;
};

export default function CheckoutOutOfStockBanner({
  warningText,
}: CheckoutOutOfStockBannerProps) {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <WarningIcon />
      </div>

      <BodyText className={styles.warningText}>
        Some products are out of stock
      </BodyText>

      <Button variant="secondary" className={styles.actionButton}>
        Review
      </Button>
    </div>
  );
}
